import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import billingNoteHelper from "../../helper/billingNoteHelper";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
import {
  ConvertPaymentGroupForCreateModel,
  GetCreateAllocationTransaction,
  GetCreateAllocationTransactionItemList,
  GetCreateDepositInput,
  GetCreateGoodsReceiptInput,
  GetCreateInvoiceInput,
  GetCreateInvoiceReceiptInput,
  GetCreateInvoiceSaleAssetInput,
  GetCreatePurchaseAssetInput,
  GetCreatePurchaseInventoryInput,
  GetCreatePurchaseOrderAssetInput,
  GetCreatePurchaseOrderInput,
  GetCreatePurchaseRequisitionInput,
  GetCreateQuotationInput,
  GetCreateReceiptInput,
  GetCreateReceiptSaleAssetInput,
  GetCreateReceivedDepositInput,
  GetEditDepositInput,
  GetEditGoodsReceiptInput,
  GetEditInvoiceInput,
  GetEditInvoiceReceiptInput,
  GetEditInvoiceSaleAssetInput,
  GetEditPurchaseAssetInput,
  GetEditPurchaseInventoryInput,
  GetEditPurchaseOrderAssetInput,
  GetEditPurchaseOrderInput,
  GetEditPurchaseRequisitionInput,
  GetEditQuotationInput,
  GetEditReceiptInput,
  GetEditReceiptSaleAssetInput,
  GetEditReceivedDepositInput,
  GetInputReferenceGoodsReceiptList,
  GetInputReferenceInvoiceReceiptList,
  default as helper,
} from "./transactionHelper";
export default {
  DoGetTagList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI.post("/api/Transaction/GetTagList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreateNewTag(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      tagName: input.tagName,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/CreateNewTag", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertTagTransaction(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionTypeId: input.transactionTypeId,
      transactionId: input.transactionId,
      tagIdList: input.tagIdList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/InsertTagTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnattachTagTransaction(tagTransactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      tagTransactionId: tagTransactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/UnattachTagTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTagDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionTypeId: input.transactionTypeId,
      transactionId: input.transactionId,
    };
    return API.peakRealTimeAPI.post("/api/Tag/GetTagDetail", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeTypeId: input.financeTypeId,
      transactionTypeId: input.transactionTypeId,
      transactionId: input.transactionId,
    };
    return API.peakRealTimeAPI.post("/api/File/GetFile", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetCommentList(transactionId, transactionType, isUseMainDatabase = false) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transactionTypeId: transactionType,
      isUseMainDatabase: isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Comment/GetCommentList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoInsertComment(input) {
    const _input = {
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType ? input.financeType : Enums.FinanceType.None,
      transactionItemType: input.transactionItemType ? input.transactionItemType : Enums.TransactionItemType.None,
      commentText: input.commentText,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Comment/InsertComment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteComment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      commentId: input.commentId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Comment/DeleteComment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetSuggestionTransactionNumber(transaction) {
    let isCreateTaxInvoice = transaction.issueTaxInvoice != null ? transaction.issueTaxInvoice.value : false;
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionType: transaction.transactionType,
      financeType: transaction.financeType,
      expenseType: helper.GetExpenseTypeForGetSuggestionTransactionNumber(transaction),
      date: transaction.date.value,
      isCreateTaxInvoice: isCreateTaxInvoice,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/GetSuggestionTransactionNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreatePurchaseRequisition(status, transaction) {
    let transactionCreate = GetCreatePurchaseRequisitionInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/CreatePurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateQuotation(status, transaction) {
    let transactionCreate = GetCreateQuotationInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/CreateQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreatePurchaseOrder(status, transaction) {
    let transactionCreate = GetCreatePurchaseOrderInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/CreatePurchaseOrder", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreatePurchaseOrderAsset(status, transaction) {
    let transactionCreate = GetCreatePurchaseOrderAssetInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/CreatePurchaseOrderAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateDeposit(status, transaction) {
    let transactionCreate = GetCreateDepositInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/CreateDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateReceivedDeposit(status, transaction) {
    let transactionCreate = GetCreateReceivedDepositInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/CreateReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateGoodsReceipt(status, transaction) {
    let transactionCreate = GetCreateGoodsReceiptInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/CreateGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateInvoiceReceipt(status, transaction) {
    let transactionCreate = GetCreateInvoiceReceiptInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/CreateInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateInvoice(status, transaction) {
    let transactionCreate = GetCreateInvoiceInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/CreateInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateInvoiceSaleAsset(status, transaction) {
    let transactionCreate = GetCreateInvoiceSaleAssetInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/CreateInvoiceSaleAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreatePurchaseInventory(status, transaction) {
    let transactionCreate = GetCreatePurchaseInventoryInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/CreatePurchaseInventory", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreatePurchaseAsset(status, transaction) {
    let transactionCreate = GetCreatePurchaseAssetInput(status, transaction);
    let _input = {
      transaction: transactionCreate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/CreatePurchaseAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateCreditNote(status, transaction) {
    let transactionInput = helper.GetCreateCreditNoteInput(status, transaction);
    let _input = {
      financeType: transactionInput.financeType,
      transactionItemType: transactionInput.transactionItemType,
      transaction: transactionInput.transaction,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/CreateCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateDebitNote(status, transaction) {
    let transactionInput = helper.GetCreateDebitNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: transactionInput.financeType,
      expenseType: transactionInput.expenseType,
      transaction: transactionInput.transaction,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/CreateDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateInvoiceWithUploadDocument(uploadDocumentList, status, transaction) {
    let transactionInput = GetCreatePurchaseInventoryInput(status, transaction);
    let _input = {
      invoice: transactionInput,
      uploadDocumentList: uploadDocumentList,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/CreateInvoiceWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoCreateReceipt(status, transaction) {
    let transactionInput = GetCreateReceiptInput(status, transaction);
    let _input = {
      receipt: transactionInput,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/CreateReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateReceiptSaleAsset(status, transaction) {
    let transactionInput = GetCreateReceiptSaleAssetInput(status, transaction);
    let _input = {
      receipt: transactionInput,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/CreateReceiptSaleAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateBillingNote(status, transaction) {
    let transactionInput = billingNoteHelper.GetCreateBillingNoteInput(status, transaction);
    let _input = {
      financeType: transactionInput.financeType,
      billingNote: transactionInput.transaction,
      isAllowDupplicateReceivedBillingNoteNumber: transaction.isAllowDupplicateReceivedBillingNoteNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/CreateBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateTaxInvoice(status, transaction) {
    let transactionInput = helper.GetCreateTaxInvoiceInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: transactionInput.financeType,
      transaction: transactionInput.transaction,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/CreateTaxInvoiceOnce", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionForCreateTaxInvoice(transactionId, transactionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionType: transactionTypeId,
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTransactionForCreateTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionListForCreateTaxInvoice(transactionTypeId, contactId, month, year, searchText) {
    let date = helper.GetFromAndToDate(month, year);
    let _input = {
      merchantId: userInfo.MerchantId(),
      taxInvoiceReferenceType: transactionTypeId,
      contactId: contactId,
      fromDate: new Date(date.fromDate).ToDateJsonString(),
      toDate: new Date(date.toDate).ToDateJsonString(),
      searchText: searchText,
    };
    return API.peakAPI
      .post("/api/Transaction/GetTransactionListForCreateTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseRequisitionDetail(purchaseRequisitionId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { purchaseRequisitionId: purchaseRequisitionId };

    return API.peakRealTimeAPI
      .get("/api/PurchaseRequisition/GetPurchaseRequisitionDetail", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationDetail(quotationId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { quotationId: quotationId };

    return API.peakRealTimeAPI.get("/api/Quotation/GetQuotationDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetPurchaseOrderDetail(purchaseOrderId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { purchaseOrderId: purchaseOrderId };

    return API.peakRealTimeAPI.get("/api/Quotation/GetPurchaseOrderDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetPurchaseOrderAssetDetail(purchaseOrderAssetId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { purchaseOrderAssetId: purchaseOrderAssetId };

    return API.peakRealTimeAPI.get("/api/Quotation/GetPurchaseOrderAssetDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetDepositDetail(depositId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { depositId: depositId };

    return API.peakRealTimeAPI.get("/api/Deposit/GetDepositDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetReceivedDepositDetail(receivedDepositId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { receivedDepositId: receivedDepositId };

    return API.peakRealTimeAPI.get("/api/Deposit/GetReceivedDepositDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetGoodsReceiptDetail(goodsReceiptId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { goodsReceiptId: goodsReceiptId };

    return API.peakRealTimeAPI.get("/api/GoodsReceipt/GetGoodsReceiptDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetInvoiceReceiptDetail(invoiceReceiptId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { invoiceReceiptId: invoiceReceiptId };

    return API.peakRealTimeAPI.get("/api/InvoiceReceipt/GetInvoiceReceiptDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetInvoiceDetail(invoiceId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { invoiceId: invoiceId };
    return API.peakRealTimeAPI.get("/api/Invoice/GetInvoiceDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetInvoiceSaleAssetDetail(invoiceSaleAssetId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { invoiceSaleAssetId: invoiceSaleAssetId };
    return API.peakRealTimeAPI.get("/api/Invoice/GetInvoiceSaleAssetDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetPurchaseInventoryDetail(purchaseInventoryId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { purchaseInventoryId: purchaseInventoryId };
    return API.peakRealTimeAPI.get("/api/Invoice/GetPurchaseInventoryDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetPurchaseAssetDetail(purchaseAssetId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { purchaseAssetId: purchaseAssetId };
    return API.peakRealTimeAPI.get("/api/Invoice/GetPurchaseAssetDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetReceiptDetail(receiptId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { receiptId: receiptId };

    return API.peakRealTimeAPI.get("/api/Receipt/GetReceiptDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetReceiptSaleAssetDetail(receiptSaleAssetId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { receiptSaleAssetId: receiptSaleAssetId };

    return API.peakRealTimeAPI.get("/api/Receipt/GetReceiptSaleAssetDetail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetUnpaidInvoiceList(financeType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: financeType,
    };
    return API.peakAPI
      .post("/api/Transaction/GetUnpaidInvoiceList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      taxInvoiceId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTaxInvoiceById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      taxInvoiceId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTaxInvoiceDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionForCreateCreditNote(input) {
    let _input = {
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetTransactionForCreateCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetCreditNoteDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetCreditNoteById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteDetailForEdit(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetCreditNoteDetailForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionForCreateDebitNote(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetTransactionForCreateDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteDetailForEdit(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteDetailForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/GetBillingNoteById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteForEditById(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/GetBillingNoteForEditById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseRequisitionForEdit(purchaseRequisitionId) {
    let _input = {
      purchaseRequisitionId: purchaseRequisitionId,
    };
    return API.peakRealTimeAPI
      .post("/api/PurchaseRequisition/GetPurchaseRequisitionForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationForEdit(quotationId) {
    let _input = {
      quotationId: quotationId,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetQuotationForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderForEdit(purchaseOrderId) {
    let _input = {
      purchaseOrderId: purchaseOrderId,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetPurchaseOrderForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetForEdit(purchaseOrderAssetId) {
    let _input = {
      purchaseOrderAssetId: purchaseOrderAssetId,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetPurchaseOrderAssetForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositForEdit(depositId) {
    let _input = {
      depositId: depositId,
    };
    return API.peakRealTimeAPI
      .post("/api/Deposit/GetDepositForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDepositForEdit(receivedDepositId) {
    let _input = {
      receivedDepositId: receivedDepositId,
    };
    return API.peakRealTimeAPI
      .post("/api/Deposit/GetReceivedDepositForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetGoodsReceiptForEdit(goodsReceiptId) {
    let _input = {
      goodsReceiptId: goodsReceiptId,
    };
    return API.peakRealTimeAPI
      .post("/api/GoodsReceipt/GetGoodsReceiptForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptForEdit(invoiceReceiptId) {
    let _input = {
      invoiceReceiptId: invoiceReceiptId,
    };
    return API.peakRealTimeAPI
      .post("/api/InvoiceReceipt/GetInvoiceReceiptForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForEdit(invoiceId) {
    let _input = {
      invoiceId: invoiceId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceSaleAssetForEdit(invoiceSaleAssetId) {
    let _input = {
      invoiceSaleAssetId: invoiceSaleAssetId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceSaleAssetForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseInventoryForEdit(purchaseInventoryId) {
    let _input = {
      purchaseInventoryId: purchaseInventoryId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetPurchaseInventoryForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetForEdit(purchaseAssetId) {
    let _input = {
      purchaseAssetId: purchaseAssetId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetPurchaseAssetForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptForEdit(receiptId) {
    let _input = {
      receiptId: receiptId,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetReceiptForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptSaleAssetForEdit(receiptId) {
    let _input = {
      receiptSaleAssetId: receiptId,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetReceiptSaleAssetForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseRequisition(transactionId, transaction, status) {
    let transactionEdit = GetEditPurchaseRequisitionInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/EditPurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditQuotation(transactionId, transaction, status) {
    let transactionEdit = GetEditQuotationInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EditQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrder(transactionId, transaction, status) {
    let transactionEdit = GetEditPurchaseOrderInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EditPurchaseOrder", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderAsset(transactionId, transaction, status) {
    let transactionEdit = GetEditPurchaseOrderAssetInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EditPurchaseOrderAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditDeposit(transactionId, transaction, status) {
    let transactionEdit = GetEditDepositInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EditDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReceivedDeposit(transactionId, transaction, status) {
    let transactionEdit = GetEditReceivedDepositInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EditReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditGoodsReceipt(transactionId, transaction, status) {
    let transactionEdit = GetEditGoodsReceiptInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/EditGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditInvoiceReceipt(transactionId, transaction, status) {
    let transactionEdit = GetEditInvoiceReceiptInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/EditInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditInvoice(transactionId, transaction, status) {
    let transactionEdit = GetEditInvoiceInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EditInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditInvoiceSaleAsset(transactionId, transaction, status) {
    let transactionEdit = GetEditInvoiceSaleAssetInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EditInvoiceSaleAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseInventory(transactionId, transaction, status) {
    let transactionEdit = GetEditPurchaseInventoryInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EditPurchaseInventory", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseAsset(transactionId, transaction, status) {
    let transactionEdit = GetEditPurchaseAssetInput(transactionId, status, transaction);
    let _input = {
      transaction: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EditPurchaseAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReceipt(transactionId, transaction, status) {
    let transactionEdit = GetEditReceiptInput(transactionId, status, transaction);
    let _input = {
      receipt: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EditReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReceiptSaleAsset(transactionId, transaction, status) {
    let transactionEdit = GetEditReceiptSaleAssetInput(transactionId, status, transaction);
    let _input = {
      receipt: transactionEdit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EditReceiptSaleAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditTaxInvoice(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateTaxInvoiceInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/EditTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditCreditNote(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateCreditNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/EditCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditDebitNote(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateDebitNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/EditDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditBillingNote(transactionId, transaction, status) {
    let transactionInput = billingNoteHelper.GetCreateBillingNoteInput(status, transaction);
    transactionInput.transaction.id = transactionId;
    let _input = {
      financeType: transactionInput.financeType,
      billingNote: transactionInput.transaction,
      billingNoteStatus: status,
      isAllowDupplicateReceivedBillingNoteNumber: transaction.isAllowDupplicateReceivedBillingNoteNumber,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/EditBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteForCreateReceipt(transactionId) {
    let _input = {
      billingNoteId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetBillingNoteForCreateReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForCreateReceipt(transactionId, paymentGroupId) {
    let _input = {
      invoiceId: transactionId,
      paymentGroupId: paymentGroupId,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetInvoiceForCreateReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceSaleAssetForCreateReceipt(transactionId, paymentGroupId) {
    let _input = {
      invoiceSaleAssetId: transactionId,
      paymentGroupId: paymentGroupId,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetInvoiceSaleAssetForCreateReceiptSaleAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceBillingNoteDetail(id) {
    let _input = {
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceBillingNoteDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteBillingNoteDetail(id) {
    let _input = {
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteBillingNoteDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositBillingNoteDetail(id) {
    let _input = {
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/Deposit/GetDepositBillingNoteDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptBillingNoteDetail(id) {
    let _input = {
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/InvoiceReceipt/GetInvoiceReceiptBillingNoteDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteSummaryByTransacrionId(input) {
    let _input = {
      transactionId: input.transactionId,
      transactionTypeId: input.transactionTypeId,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetCreditNoteSummaryByTransacrionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteSummaryByTransacrionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionTypeId: input.transactionTypeId,
      financeTypeId: input.financeTypeId,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteSummaryByTransacrionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidPaidPayment(paymentGroupId, transactionId, transactionType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      paymentGroupId: paymentGroupId,
      transactionId: transactionId,
      transactionType: transactionType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Payment/VoidPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoPaidPaymentByTransactionType(transactionId, transactionType, payment) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transactionType: transactionType,
      payment: helper.ConvertPaymentForCreate(payment),
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Payment/PaidPaymentByTransactionType", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoPaidPaymentByDeposit(transactionId, payment) {
    let _input = {
      depositId: transactionId,
      paymentGroup: ConvertPaymentGroupForCreateModel(payment, Enums.FinanceType.InFlow),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/PaidPaymentByDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoPaidPaymentByReceivedDeposit(transactionId, payment) {
    let _input = {
      receivedDepositId: transactionId,
      paymentGroup: ConvertPaymentGroupForCreateModel(payment, Enums.FinanceType.OutFlow),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/PaidPaymentByReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoPaidPaymentByInvoiceReceipt(transactionId, payment) {
    let _input = {
      invoiceReceiptId: transactionId,
      paymentGroup: ConvertPaymentGroupForCreateModel(payment, Enums.FinanceType.OutFlow),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/PaidPaymentByInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoPaidPaymentInvoice(transactionId, payment) {
    let _input = {
      invoiceId: transactionId,
      paymentGroup: ConvertPaymentGroupForCreateModel(payment, Enums.FinanceType.InFlow),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/PaidPaymentInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoPaidPaymentInvoiceSaleAsset(transactionId, payment) {
    let _input = {
      invoiceSaleAssetId: transactionId,
      paymentGroup: ConvertPaymentGroupForCreateModel(payment, Enums.FinanceType.InFlow),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/PaidPaymentInvoiceSaleAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoPaidPaymentPurchaseInventory(transactionId, payment) {
    let _input = {
      purchaseInventoryId: transactionId,
      paymentGroup: ConvertPaymentGroupForCreateModel(payment, Enums.FinanceType.OutFlow),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/PaidPaymentPurchaseInventory", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoPaidPaymentPurchaseAsset(transactionId, payment) {
    let _input = {
      purchaseAssetId: transactionId,
      paymentGroup: ConvertPaymentGroupForCreateModel(payment, Enums.FinanceType.OutFlow),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/PaidPaymentPurchaseAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositForDoPaidPayment(transactionId) {
    let _input = {
      depositId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Deposit/GetDepositForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDepositForDoPaidPayment(receivedDepositId) {
    let _input = {
      receivedDepositId: receivedDepositId,
    };
    return API.peakRealTimeAPI
      .post("/api/Deposit/GetReceivedDepositForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptForDoPaidPayment(invoiceReceiptId) {
    let _input = {
      invoiceReceiptId: invoiceReceiptId,
    };
    return API.peakRealTimeAPI
      .post("/api/InvoiceReceipt/GetInvoiceReceiptForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForPaidPayment(invoiceId) {
    let _input = {
      invoiceId: invoiceId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceForPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceSaleAssetForPaidPayment(invoiceSaleAssetId) {
    let _input = {
      invoiceSaleAssetId: invoiceSaleAssetId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceSaleAssetForPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseInventoryForPaidPayment(purchaseInventoryId) {
    let _input = {
      purchaseInventoryId: purchaseInventoryId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetPurchaseInventoryForPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetForPaidPayment(purchaseAssetId) {
    let _input = {
      purchaseAssetId: purchaseAssetId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetPurchaseAssetForPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteForDoPaidPayment(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetCreditNoteForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteForDoPaidPayment(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetDebitNoteForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteForDoPaidPayment(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetBillingNoteForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByQuotationId(transactionId) {
    let _input = {
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetTimelineByQuotationId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByInvoiceId(transactionId, isQueryAllTimeLine) {
    let _input = {
      transactionId: transactionId,
      isQueryAllTimeLine: isQueryAllTimeLine,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetTimelineByInvoiceId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByReceiptId(transactionId, isQueryAllTimeLine) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      isQueryAllTimeLine: isQueryAllTimeLine,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetTimelineByReceiptId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByTaxInvoiceId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTimelineByTaxInvoiceId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByDepositId(depositId) {
    let _input = {
      depositId: depositId,
    };
    return API.peakRealTimeAPI
      .post("/api/Deposit/GetDepositTimeline", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByBillingNoteId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/GetTimelineByBillingNoteId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByCreditNoteId(transactionId) {
    let _input = {
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetTimelineByCreditNoteId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByDebitNoteId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetTimelineByDebitNoteId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  IsInvoiceInBillingNoteHaveTaxInvoiceByBillingNoteId(billingNoteId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      billingNoteId: billingNoteId,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/IsInvoiceInBillingNoteHaveTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByPurchaseRequisitionId(input) {
    let _input = {
      purchaseRequisitionId: input.purchaseRequisitionId,
      isGetAllTimeline: input.isGetAllTimeline,
    };
    return API.peakRealTimeAPI
      .post("/api/PurchaseRequisition/GetTimelineByPurchaseRequisitionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByPurchaseOrderId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetTimelineByPurchaseOrderId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByExpenseId(transactionId) {
    let _input = {
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetTimelineByExpenseId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByReceivedDepositId(receivedDepositId) {
    let _input = {
      receivedDepositId: receivedDepositId,
    };
    return API.peakRealTimeAPI
      .post("/api/Deposit/GetReceivedDepositTimeline", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByGoodsReceiptId(goodsReceiptId) {
    let _input = {
      goodsReceiptId: goodsReceiptId,
    };
    return API.peakRealTimeAPI
      .post("/api/GoodsReceipt/GetGoodsReceiptTimeline", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByInvoiceReceiptId(invoiceReceiptId) {
    let _input = {
      invoiceReceiptId: invoiceReceiptId,
    };
    return API.peakRealTimeAPI
      .post("/api/InvoiceReceipt/GetInvoiceReceiptTimeline", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidQuotation(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/VoidQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/VoidInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidReceipt(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/VoidReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidTaxInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/VoidTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidCreditNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/VoidCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidBillingNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/VoidBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidDebitNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/VoidDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidPurchaseRequisition(transactionId) {
    let _input = {
      purchaseRequisitionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/VoidPurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidDeposit(transactionId) {
    let _input = {
      depositId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/VoidDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidReceivedDeposit(transactionId) {
    let _input = {
      receivedDepositId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/VoidReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidGoodsReceipt(transactionId) {
    let _input = {
      goodsReceiptId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/VoidGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidInvoiceReceipt(transactionId) {
    let _input = {
      invoiceReceiptId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/VoidInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRejectTransaction(input) {
    let _input = {
      data: {
        merchantId: userInfo.MerchantId(),
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        comment: input.comment,
        financeType: input.financeType,
        rejectType: input.rejectType,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/RejectTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRejectPurchaseRequisition(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
      comment: input.comment,
      rejectType: input.rejectType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/RejectPurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeclineJournal(input) {
    let _input = {
      journalId: input.transactionId,
      comment: input.comment,
      declineType: input.rejectType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/DeclineJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRejectDeposit(input) {
    let _input = {
      depositId: input.transactionId,
      comment: input.comment,
      rejectType: input.rejectType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/RejectDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRejectReceivedDeposit(input) {
    let _input = {
      receivedDepositId: input.transactionId,
      comment: input.comment,
      rejectType: input.rejectType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/RejectReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRejectGoodsReceipt(input) {
    let _input = {
      goodsReceiptId: input.transactionId,
      comment: input.comment,
      rejectType: input.rejectType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/RejectGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRejectInvoiceReceipt(input) {
    let _input = {
      invoiceReceiptId: input.transactionId,
      comment: input.comment,
      rejectType: input.rejectType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/RejectInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#region InsertFileTransaction
  DoInsertQuotationFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/Quotation/InsertQuotationFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertInvoiceFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/Invoice/InsertInvoiceFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertReceiptFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/Receipt/InsertReceiptFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertTaxInvoiceFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/TaxInvoice/InsertTaxInvoiceFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertCreditNoteFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/CreditNote/InsertCreditNoteFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertDebitNoteFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/DebitNote/InsertDebitNoteFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertBillingNoteFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/BillingNote/InsertBillingNoteFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertDepositFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("depositId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/Deposit/InsertDepositFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertReceivedDepositFile(input) {
    let formData = new FormData();
    formData.append("receivedDepositId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/Deposit/InsertReceivedDepositFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertGoodsReceiptFile(input) {
    let formData = new FormData();
    formData.append("goodsReceiptId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/GoodsReceipt/InsertGoodsReceiptFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertInvoiceReceiptFile(input) {
    let formData = new FormData();
    formData.append("invoiceReceiptId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/InvoiceReceipt/InsertInvoiceReceiptFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertPurchaseRequisitionFile(input) {
    let formData = new FormData();
    formData.append("purchaseRequisitionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/PurchaseRequisition/InsertPurchaseRequisitionFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region deleteFile
  DoDeleteQuotationFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/DeleteQuotationFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteDepositFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/DeleteDepositFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteInvoiceFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/DeleteInvoiceFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteReceiptFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/DeleteReceiptFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteTaxinvoiceFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Taxinvoice/DeleteTaxinvoiceFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteCreditNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/DeleteCreditNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteDebitNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/DeleteDebitNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteBillingNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/DeleteBillingNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteDepositFile(input) {
    let _input = {
      depositId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/DeleteDepositFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteReceivedDepositFile(input) {
    let _input = {
      receivedDepositId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/DeleteReceivedDepositFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteGoodsReceiptFile(input) {
    let _input = {
      goodsReceiptId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/DeleteGoodsReceiptFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteInvoiceReceiptFile(input) {
    let _input = {
      invoiceReceiptId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/DeleteInvoiceReceiptFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  DoGetPaymentGroupListAndReferenceJournalDetail(input) {
    let _input = {
      transactionId: input.transactionId,
      transactionType: input.transactionTypeId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentGroupListAndReferenceJournalDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReferenceTransactionPaymentByTransactionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionTypeId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetReferenceTransactionPaymentByTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByBillingNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };

    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByCreditNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };

    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByDebitNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };

    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByReceipt(transactionId) {
    let _input = {
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#region bookmark
  DoCreateBookmark(input) {
    let transactionInput = helper.GetCreateBookmarkInput(input.bookmark, input.transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transaction: transactionInput,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Bookmark/SaveBookmark", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditBookmark(bookmark) {
    let _input = {
      bookmark: {
        id: bookmark.id,
        name: bookmark.name,
        description: bookmark.description,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Bookmark/EditBookmark", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBookmarkList(input) {
    let _input = helper.GetBookmarkListInput(input);
    return API.peakAPI.post("/api/Bookmark/GetBookmarkList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBookmarkTemplateList(bookmarkId) {
    let _input = helper.GetBookmarkTemplateInput(bookmarkId);
    return API.peakRealTimeAPI
      .post("/api/Bookmark/GetBookmarkDetailById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBookmarkDetailList(transactionTemplateId) {
    let _input = helper.GetBookmarkDetailListInput(transactionTemplateId);
    return API.peakRealTimeAPI
      .post("/api/Bookmark/GetBookmarkDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteBookmark(bookmarkId) {
    let _input = helper.DeleteBookmarkInput(bookmarkId);
    return API.peakRealTimeAPIForTransaction
      .post("/api/Bookmark/DeletedBookmark", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAISuggestionAccountByContact(contactId, financeType, transactionType, transactionItemTypeList) {
    let _input = {
      contactId: contactId,
      financeType: financeType,
      transactionType: transactionType,
      transactionItemTypeList: transactionItemTypeList,
    };
    return API.peakRealTimeAPI
      .post("/api/transaction/GetAISuggestionAccountByContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region purchase taxinvoice
  DoCreateReceivedTaxInvoice(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receivedTaxInvoiceList: [],
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      paymentGroupId: input.referencePaymentGroupId,
      language: i18n.locale,
    };
    if (input.receivedTaxInvoiceList && input.receivedTaxInvoiceList) {
      for (let receivedTaxInvoice of input.receivedTaxInvoiceList) {
        _input.receivedTaxInvoiceList.push({
          receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
          receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
          receivedTaxInvoiceJournalDate: receivedTaxInvoice.receivedTaxInvoiceJournalDate,
          preVatTotal: receivedTaxInvoice.preVatTotal,
          vatTotal: receivedTaxInvoice.vatTotal,
          netAmount: receivedTaxInvoice.netAmount,
        });
      }
    }
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/DoCreateReceivedTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidReceivedTaxInvoice(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receivedTaxInvoice: {
        receivedTaxInvoiceNumber: input.receivedTaxInvoice.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
        receivedTaxInvoiceJournalDate: input.receivedTaxInvoice.receivedTaxInvoiceJournalDate,
        preVatTotal: input.receivedTaxInvoice.preVatTotal,
        vatTotal: input.receivedTaxInvoice.vatTotal,
        netAmount: input.receivedTaxInvoice.netAmount,
        referenceTransactionId: input.transactionId,
        referenceTransactionType: input.transactionType,
        referencePaymentGroupId: input.referencePaymentGroupId,
        id: input.receivedTaxInvoice.id,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/VoidReceivedTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetReceivedTaxInvoiceByReferenceTransactionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetReceivedTaxInvoiceByReferenceTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRerecordJournalReceivedTaxInvoice(input) {
    let _input = {
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      receivedTaxInvoiceId: input.receivedTaxInvoiceId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/RerecordJournalReceivedTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region recurring
  DoGetSuggestionRecurringNumber(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionType: input.transactionType,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/GetSuggestionRecurringNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateRecurringInvoice(invoiceRecurringTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      invoiceRecurringTemplate: invoiceRecurringTemplate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Recurring/CreateRecurringInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateRecurringReceipt(receiptRecurringTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receiptRecurringTemplate: receiptRecurringTemplate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Recurring/CreateRecurringReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRecurringInvoiceTemplateDetail(recurringTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: recurringTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/GetRecurringInvoiceTemplateDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRecurringReceiptTemplateDetail(recurringTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: recurringTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/GetRecurringReceiptTemplateDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringInvoiceTemplate(invoiceRecurringTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: invoiceRecurringTemplate.id,
      invoiceRecurringTemplate: invoiceRecurringTemplate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Recurring/UpdateRecurringInvoiceTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringReceiptTemplate(receiptRecurringTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: receiptRecurringTemplate.id,
      receiptRecurringTemplate: receiptRecurringTemplate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Recurring/UpdateRecurringReceiptTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringIsArchive(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: input.recurringTemplateId,
      isArchive: input.isArchive,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Recurring/UpdateRecurringIsArchive", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringIsAutoSendEmail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: input.recurringTemplateId,
      isAutoSendEmail: input.isAutoSendEmail,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Recurring/UpdateRecurringIsAutoSendEmail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringIsDelete(recurringTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: recurringTemplateId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Recurring/UpdateRecurringIsDelete", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  DoSendEmailTransaction(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      financeType: input.financeType,
      transactionType: input.transactionType,
      emailMessage: {
        toEmail: input.toEmail,
        toBccEmail: input.bccEmail,
        toCcEmail: input.ccEmail,
        linkFile: input.linkFile,
        messageFromSender: input.messageFromSender,
        messageSubject: input.subject,
        sendEmail: input.sendEmail.email,
        selectLanguageTemplateId: input.selectTemplateId,
        contactPerson: input.contactPerson,
        isShowInformationSender: input.isShowInformationSender,
        isShowImageSender: input.isShowImageSender,
        isShowPayment: input.isShowPayment,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/SendEmailTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#region EditAllocation
  DoEasyEditPurchaseRequisitionAllocation(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/EasyEditPurchaseRequisitionAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseOrderAllocation(input) {
    let _input = {
      purchaseOrderId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditQuotationAllocation(input) {
    let _input = {
      quotationId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditQuotationAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceAllocation(input) {
    let _input = {
      invoiceId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditInvoiceAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceSaleAssetAllocation(input) {
    let _input = {
      invoiceSaleAssetId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditInvoiceSaleAssetAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseInventoryAllocation(input) {
    let _input = {
      purchaseInventoryId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditPurchaseInventoryAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseAssetAllocation(input) {
    let _input = {
      purchaseAssetId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditPurchaseAssetAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceiptAllocation(input) {
    let _input = {
      receiptId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditReceiptAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceiptSaleAssetAllocation(input) {
    let _input = {
      receiptSaleAssetId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditReceiptSaleAssetAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditCreditNoteAllocation(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/EditCreditNoteAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditDebitNoteAllocation(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/EditDebitNoteAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditDepositAllocation(input) {
    let _input = {
      depositId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditDepositAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceivedDepositAllocation(input) {
    let _input = {
      receivedDepositId: input.transactionId,
      allocationTransactionList: GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: GetCreateAllocationTransactionItemList(input.allocationTransactionItemList),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditReceivedDepositAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  DoLockPurchaseRequisition(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/LockPurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnLockPurchaseRequisition(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/UnLockPurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoLockDeposit(input) {
    let _input = {
      depositId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/LockDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnLockDeposit(input) {
    let _input = {
      depositId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/UnLockDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoLockReceivedDeposit(input) {
    let _input = {
      receivedDepositId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/LockReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnLockReceivedDeposit(input) {
    let _input = {
      receivedDepositId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/UnLockReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoLockGoodsReceipt(input) {
    let _input = {
      goodsReceiptId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/LockGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnLockGoodsReceipt(input) {
    let _input = {
      goodsReceiptId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/UnLockGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoLockInvoiceReceipt(input) {
    let _input = {
      invoiceReceiptId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/LockInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnLockInvoiceReceipt(input) {
    let _input = {
      invoiceReceiptId: input.transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/UnLockInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoLockTransactionByTransactionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/LockTransactionByTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnLockTransactionByTransactionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/UnLockTransactionByTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  RerecordStockActivityByInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/RerecordStockActivityByInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  RerecordStockActivityByReceipt(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/RerecordStockActivityByReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateInvoiceDetailDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        transactionId: input.transactionId,
        updateVersion: input.updateVersion,
        language: i18n.locale == "th" ? 1 : 0,
      },
    };
    return API.peakOnlineView
      .post("/api/Invoice/UpdateInvoiceDetailDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateReceiptDetailDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        transactionId: input.transactionId,
        updateVersion: input.updateVersion,
        language: i18n.locale == "th" ? 1 : 0,
      },
    };
    return API.peakOnlineView
      .post("/api/Receipt/UpdateReceiptDetailDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateTaxInvoiceDetailDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        transactionId: input.transactionId,
        updateVersion: input.updateVersion,
        language: i18n.locale == "th" ? 1 : 0,
      },
    };
    return API.peakOnlineView
      .post("/api/TaxInvoice/UpdateTaxInvoiceDetailDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateCreditNoteDetailDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        transactionId: input.transactionId,
        updateVersion: input.updateVersion,
        language: i18n.locale == "th" ? 1 : 0,
      },
    };
    return API.peakOnlineView
      .post("/api/CreditNote/UpdateCreditNoteDetailDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateDebitNoteDetailDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        transactionId: input.transactionId,
        updateVersion: input.updateVersion,
        language: i18n.locale == "th" ? 1 : 0,
      },
    };
    return API.peakOnlineView
      .post("/api/DebitNote/UpdateDebitNoteDetailDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteReferenceDocumentPaymentList(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Finance/GetAutoCompleteReferenceDocumentPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteReferenceDocumentPaymentListByTransaction(input) {
    let _input = {
      contactId: input.contactId,
      referenceTransactionType: input.referenceTransactionType,
      transactionType: input.transactionType,
      transactionId: input.transactionId,
      financeType: input.financeType,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Finance/GetAutoCompleteReferenceDocumentPaymentByTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteTransactionForCreateCreditNote(input) {
    let _input = {
      contactId: input.contactId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Transaction/GetAutoCompleteTransactionForCreateCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteTransactionForCreateDebitNote(input) {
    let _input = {
      contactId: input.contactId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Transaction/GetAutoCompleteTransactionForCreateDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalInvoice(transactionId) {
    let _input = {
      invoiceId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/ReRecordJournalInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalInvoiceSaleAsset(transactionId) {
    let _input = {
      invoiceSaleAssetId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/ReRecordJournalInvoiceSaleAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalPurchaseInventory(transactionId) {
    let _input = {
      purchaseInventoryId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/ReRecordJournalPurchaseInventory", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalPurchaseAsset(transactionId) {
    let _input = {
      purchaseAssetId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/ReRecordJournalPurchaseAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalReceipt(transactionId) {
    let _input = {
      transactionId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/ReRecordJournalReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalReceiptSaleAsset(transactionId) {
    let _input = {
      receiptSaleAssetId: transactionId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/ReRecordJournalReceiptSaleAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalDebitNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/ReRecordJournalDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalCreditNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/ReRecordJournalCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForCreateBillingNoteByInvoiceId(invoiceId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { invoiceId: invoiceId };

    return API.peakRealTimeAPI
      .get("/api/BillingNote/GetInvoiceForCreateBillingNoteByInvoiceId", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteForCreateBillingNoteByDebitNoteId(debitNoteId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { debitNoteId: debitNoteId };

    return API.peakRealTimeAPI
      .get("/api/BillingNote/GetDebitNoteForCreateBillingNoteByDebitNoteId", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetDepositForCreateBillingNoteByDepositId(depositId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { depositId: depositId };

    return API.peakRealTimeAPI
      .get("/api/BillingNote/GetDepositForCreateBillingNoteByDepositId", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptForCreateBillingNoteByInvoiceReceiptId(invoiceReceiptId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { invoiceReceiptId: invoiceReceiptId };

    return API.peakRealTimeAPI
      .get("/api/BillingNote/GetInvoiceReceiptForCreateBillingNoteByInvoiceReceiptId", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForEditBillingNoteByInvoiceId(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { invoiceId: input.invoiceId, ignoreBillingNoteId: input.ignoreBillingNoteId };

    return API.peakRealTimeAPI
      .get("/api/BillingNote/GetInvoiceForEditBillingNoteByInvoiceId", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteForEditBillingNoteByDebitNoteId(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { debitNoteId: input.debitNoteId, ignoreBillingNoteId: input.ignoreBillingNoteId };

    return API.peakRealTimeAPI
      .get("/api/BillingNote/GetDebitNoteForEditBillingNoteByDebitNoteId", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetDepositForEditBillingNoteByDepositId(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { depositId: input.depositId, ignoreBillingNoteId: input.ignoreBillingNoteId };

    return API.peakRealTimeAPI
      .get("/api/BillingNote/GetDepositForEditBillingNoteByDepositId", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptForEditBillingNoteByInvoiceReceiptId(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { invoiceReceiptId: input.invoiceReceiptId, ignoreBillingNoteId: input.ignoreBillingNoteId };

    return API.peakRealTimeAPI
      .get("/api/BillingNote/GetInvoiceReceiptForEditBillingNoteByInvoiceReceiptId", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoSendApprovedTransaction(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        transactionId: input.transactionId,
        approvedUserId: input.sendApprove.userSendApproveId,
        transactionType: input.sendApprove.transactionType,
        expenseType: input.sendApprove.expenseType,
        financeType: input.sendApprove.financeType,
        isSendEmail: input.sendApprove.isSendEmail,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/SendApprovedTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositRemainingList(depositIdList) {
    let _input = {
      depositIdList: depositIdList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/GetDepositRemainingList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositIdByQuotation(quotationId) {
    let _input = {
      quotationId: quotationId,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetDepositIdByQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositRemainingListForEdit(depositIdList, transactionId, transactionType) {
    let _input = {
      depositIdList: depositIdList,
      transactionId: transactionId,
      transactionType: transactionType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/GetDepositRemainingListForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDepositRemainingList(receivedDepositIdList) {
    let _input = {
      receivedDepositIdList: receivedDepositIdList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/GetReceivedDepositRemainingList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDepositRemainingListForEdit(receivedDepositIdList, transactionId, transactionType) {
    let _input = {
      receivedDepositIdList: receivedDepositIdList,
      transactionId: transactionId,
      transactionType: transactionType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/GetReceivedDepositRemainingListForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptRemainingList(invoiceReceiptIdList, goodsReceiptId) {
    const _input = {
      invoiceReceiptIdList: invoiceReceiptIdList,
      goodsReceiptId: goodsReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/GetInvoiceReceiptRemainingList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetGoodsReceiptRemainingList(goodsReceiptIdList, invoiceReceiptId) {
    const _input = {
      goodsReceiptIdList: goodsReceiptIdList,
      invoiceReceiptId: invoiceReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/GetGoodsReceiptRemainingList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReferenceGoodsReceipt(transactionReferenceTransactionModel, invoiceReceiptId) {
    const _input = {
      referenceGoodsReceiptList: GetInputReferenceGoodsReceiptList(transactionReferenceTransactionModel),
      invoiceReceiptId: invoiceReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/ReferenceGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReferenceInvoiceReceipt(transactionReferenceTransactionModel, goodsReceiptId) {
    const _input = {
      referenceInvoiceReceiptList: GetInputReferenceInvoiceReceiptList(transactionReferenceTransactionModel),
      goodsReceiptId: goodsReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/ReferenceInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetGoodsReceiptReferenceInvoiceReceiptDetailList(goodsReceiptId) {
    const _input = {
      goodsReceiptId: goodsReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/GetGoodsReceiptReferenceInvoiceReceiptDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptReferenceGoodsReceiptDetailList(invoiceReceiptId) {
    const _input = {
      invoiceReceiptId: invoiceReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/GetInvoiceReceiptReferenceGoodsReceiptDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidReferenceGoodsReceipt(invoiceReceiptId, goodsReceiptId) {
    const _input = {
      invoiceReceiptId: invoiceReceiptId,
      goodsReceiptId: goodsReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/VoidReferenceGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidReferenceInvoiceReceipt(invoiceReceiptId, goodsReceiptId) {
    const _input = {
      invoiceReceiptId: invoiceReceiptId,
      goodsReceiptId: goodsReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/VoidReferenceInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionReferenceDepositDetail(depositId) {
    const _input = {
      depositId: depositId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/GetTransactionReferenceDepositDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateCreateTransactionCreditLimit(input) {
    const _input = {
      contactId: input.contactId,
      transactionType: input.transactionType,
      fromCurrencyNetTotal: input.fromCurrencyNetTotal,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/ValidateCreateTransactionCreditLimit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateEditTransactionCreditLimit(input) {
    const _input = {
      contactId: input.contactId,
      transactionType: input.transactionType,
      fromCurrencyNetTotal: input.fromCurrencyNetTotal,
      transactionId: input.transactionId,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/ValidateEditTransactionCreditLimit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateQuotationStatusBackToAwaitAccepted(input) {
    const _input = {
      quotationId: input.quotationId,
      status: input.status,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateQuotationStatusBackToAwaitAccepted", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteViewDetailList(billingNoteIdList) {
    let _input = {
      billingNoteIdList: billingNoteIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetBillingNoteViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteViewDetailList(creditNoteIdList) {
    let _input = {
      creditNoteIdList: creditNoteIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetCreditNoteViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositViewDetailList(depositIdList) {
    let _input = {
      depositIdList: depositIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetDepositViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteViewDetailList(debitNoteIdList) {
    let _input = {
      debitNoteIdList: debitNoteIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetDebitNoteViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseRequisitionViewDetailList(purchaseRequisitionIdList) {
    let _input = {
      purchaseRequisitionIdList: purchaseRequisitionIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetPurchaseRequisitionViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetGoodsReceiptViewDetailList(goodsReceiptIdList) {
    let _input = {
      goodsReceiptIdList: goodsReceiptIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetGoodsReceiptViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceViewDetailList(invoiceIdList) {
    let _input = {
      invoiceIdList: invoiceIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetInvoiceViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptViewDetailList(invoiceReceiptIdList) {
    let _input = {
      invoiceReceiptIdList: invoiceReceiptIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetInvoiceReceiptViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptViewDetailList(receiptIdList) {
    let _input = {
      receiptIdList: receiptIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetReceiptViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationViewDetailList(quotationIdList) {
    let _input = {
      quotationIdList: quotationIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetQuotationViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceViewDetailList(taxInvoiceIdList) {
    let _input = {
      taxInvoiceIdList: taxInvoiceIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetTaxInvoiceViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChequeViewDetailList(chequeIdList) {
    let _input = {
      chequeIdList: chequeIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetChequeViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentTransferViewDetailList(bankAccountId, paymentGroupIdList) {
    let _input = {
      bankAccountId: bankAccountId,
      paymentGroupIdList: paymentGroupIdList,
    };
    return API.peakAPI
      .post("/api/Transaction/GetPaymentTransferViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseRequisitionIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/GetPurchaseRequisitionIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      transactionItemType: input.transactionItemType,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/GetQuotationIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/GetDepositIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetGoodsReceiptIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/GetGoodsReceiptIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/GetInvoiceReceiptIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      transactionItemType: input.transactionItemType,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/GetInvoiceIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      transactionItemType: input.transactionItemType,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/GetReceiptIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/GetTaxInvoiceIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/GetCreditNoteIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/GetDebitNoteIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteIdByNavigation(input) {
    let _input = {
      transactionId: input.transactionId,
      financeTypeId: input.financeTypeId,
      status: input.status,
      isDeleted: input.isDeleted,
      navigationType: input.navigationType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/GetBillingNoteIdByNavigation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationForCreateTransaction(input) {
    const _input = {
      quotationId: input.quotationId,
      transactionType: input.transaction.transactionType,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/GetQuotationForCreateTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  IsToCurrencyNetTotalOverTransactionReferenceQuotation(input) {
    const _input = {
      quotationId: input.quotationId,
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      toCurrencyNetTotal: input.toCurrencyNetTotal,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/IsToCurrencyNetTotalOverTransactionReferenceQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateQuotationStatusCompletely(input) {
    const _input = {
      quotationId: input.quotationId,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateQuotationStatusCompletely", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateQuotationStatusUnCompletely(input) {
    const _input = {
      quotationId: input.quotationId,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateQuotationStatusUnCompletely", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAcceptTaskPurchaseRequisition(input) {
    const _input = {
      purchaseRequisitionId: input.purchaseRequisitionId,
      purchaseRequisitionStatus: input.purchaseRequisitionStatus,
      comment: input.comment,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/UpdateAcceptTaskPurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSuccessfulPurchaseRequisition(input) {
    const _input = {
      purchaseRequisitionId: input.purchaseRequisitionId,
      isSuccessful: input.isSuccessful,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/UpdateSuccessfulPurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateQuotationMatchConditionCompletelyStatus(input) {
    const _input = {
      quotationId: input.quotationId,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/ValidateQuotationMatchConditionCompletelyStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceListByRefTransaction(input) {
    let _input = {
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/GetTaxInvoiceListByRefTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPP30TransactionDetailBySourceId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        financeType: input.financeType,
        sourceId: input.sourceId,
        sourceType: input.sourceType,
      },
    };
    return API.peakTaxService
      .post("/api/Transaction/GetPP30TransactionDetailBySourceId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPNDTransactionDetailBySourceId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        financeType: input.financeType,
        sourceId: input.sourceId,
        sourceType: input.sourceType,
      },
    };
    return API.peakTaxService
      .post("/api/WhtCertificate/GetWhtCertificateDetailBySourceId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDailyJournalViewDetailList(input) {
    let _input = {
      journalIdList: input,
    };
    return API.peakAPI
      .post("/api/Journal/GetJournalViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  }
};
